export const PHONE_NUMBER_AS_WHATSAPP_NUMBER_TYPE = ['yes', 'no'] as const;
